import React, { useEffect, useRef } from 'react';

import styled from '@emotion/styled';

import ActiveShifts from './ActiveShifts/ActiveShifts';
import ApplicationStatistics from './ApplicationStatistics/ApplicationStatistics';
import Banner from './Banner/Banner';
import YourPostedJobs from './YourPostedJobs/YourPostedJobs';
import { ModalProvider } from '../../../context/ModalContext';
import ModalTriggerContainer from '../../../components/Modals/ModalTriggerContainer';
import UploadGovIdModal from '../../../components/Modals/ModalsActions/UploadGovIdModal';
import { Modal } from '../../../components/Modals/Modal';
import { useAppSelector } from '../../../redux/store';
import VerificationPromptModal from '../../../components/Modals/ModalsActions/VerificationPromptModal';
import Page from '../../../components/Page/Page';
import { ToggleButton } from '../../../components/ToggleButton/ToggleButton';
import useUpdateAvailabilityStatus from '../../../hooks/dashboard/settings/profilesetting/useUpdateAvailabilityStatus';
// import InfoIcon from '../../../components/Icons/InfoIcon';
import { formatRoundedCount } from '../../../utils/utils';

const ShowModal = React.forwardRef<HTMLDivElement>((props, ref) => {
  const { authData } = useAppSelector((state) => state.auth);

  return (
    <ModalProvider>
      <ModalTriggerContainer ref={ref}>
        <></>
      </ModalTriggerContainer>
      <Modal>
        {authData?.tier === 'TIER 1' ? (
          <UploadGovIdModal />
        ) : authData?.tier === 'TIER 2' ? (
          <VerificationPromptModal />
        ) : (
          ''
        )}
      </Modal>
    </ModalProvider>
  );
});

const DashboardHome = () => {
  const { authData } = useAppSelector((state) => state.auth);

  const availabilityCount = useAppSelector(
    (state) => state.availabilityCount.count
  );

  const { updateAvailability, loading } = useUpdateAvailabilityStatus();

  const triggerRef = useRef<HTMLDivElement>(null);

  const neverSubmitted =
    authData?.governmentIdStatus === 'Pending' &&
    authData?.governmentId === null;

  const pendingSubmitted =
    authData?.governmentIdStatus === 'Pending' &&
    authData?.governmentId !== null;

  const rejected =
    authData?.governmentIdStatus === 'Rejected' &&
    authData?.governmentId !== null;

  console.log(neverSubmitted, pendingSubmitted, rejected);

  // When the component mounts, check if sign‑in was successful and trigger the modal click if user is a tier 1 user..
  useEffect(() => {
    // Tier-1 flow
    if (
      sessionStorage.getItem('postSignInAction') === 'true' &&
      authData?.tier === 'TIER 1' &&
      (neverSubmitted || (rejected && !pendingSubmitted))
    ) {
      triggerRef.current?.click();
      return; // stop here if Tier-1 matched
    }

    // record that Tier-2 was reached
    // if (
    //   authData?.tier === 'TIER 2' &&
    //   localStorage.getItem('tier2Action') === 'true'
    // ) {
    //   localStorage.setItem('tier2Action', 'true');
    // }

    // now check the “both postSignInAction AND tier2Action” case.
    if (
      authData?.tier === 'TIER 2' &&
      sessionStorage.getItem('postSignInAction') === 'true' &&
      localStorage.getItem('tier2Action') === 'true'
    ) {
      triggerRef.current?.click();
      sessionStorage.removeItem('postSignInAction');
    }
  }, [authData?.tier, neverSubmitted, pendingSubmitted, rejected]);

  const handleToggleAvailability = () => {
    updateAvailability({
      isAvailableForWork: !authData?.isAvailableForWork,
    });
  };

  return (
    <Page title="Locumspace | Dashboard">
      <Container className="default-margin">
        <Avail>
          {authData?.isAvailableForWork ? (
            <p>
              You have joined {formatRoundedCount(availabilityCount)}{' '}
              professionals <b>available to work</b>. Keep an eye out for new opportunities.
            </p>
          ) : (
            <p>
              There are more than {formatRoundedCount(availabilityCount)} users
              available to work. Turn on availability to join them.
            </p>
          )}

          <div>
            <ToggleButton
              controller={handleToggleAvailability}
              defaultState={authData?.isAvailableForWork}
              loading={loading}
            />
            {/* <span>
              {' '}
              <InfoIcon />{' '}
              {authData?.isAvailableForWork
                ? 'availability on'
                : 'availability off'}
            </span> */}
          </div>
        </Avail>
        <Banner />
        <ApplicationStatistics />
        <ContentGrid>
          <ActiveShifts />
          <YourPostedJobs />
        </ContentGrid>
        {/* <RecommendedJob /> */}
        <ShowModal ref={triggerRef} />
      </Container>
    </Page>
  );
};

export default DashboardHome;

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 32px 0;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.75rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Avail = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -5%;
  text-align: center;
  gap: 1rem;

  & > div {
    display: flex;
    gap: 0.3rem;
    & > span {
      font-size: 14px;
      color: ${({ theme }) => theme.palette.greyGrey3};
      display: flex;
      align-items: center;
      gap: 0.3rem;
    }
  }

  @media (max-width: 768px) {
    font-size: 15px;
    flex-direction: column;
  }
`;
